"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import './style.scss'
var MaterialIcon = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(MaterialIcon, _Component);

  function MaterialIcon() {
    (0, _classCallCheck2["default"])(this, MaterialIcon);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MaterialIcon).apply(this, arguments));
  }

  (0, _createClass2["default"])(MaterialIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          size = _this$props.size,
          color = _this$props.color,
          style = _this$props.style,
          marginTop = _this$props.marginTop,
          className = _this$props.className,
          title = _this$props.title;
      return _react["default"].createElement("i", {
        onClick: this.props.onClick,
        title: title,
        style: _objectSpread({
          fontSize: size,
          color: color,
          marginTop: marginTop
        }, style),
        className: (className || '') + ' material-icons'
      }, icon);
    }
  }]);
  return MaterialIcon;
}(_react.Component);

MaterialIcon.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].number,
  color: _propTypes["default"].string,
  className: _propTypes["default"].string,
  title: _propTypes["default"].string,
  style: _propTypes["default"].object,
  marginTop: _propTypes["default"].number,
  onClick: _propTypes["default"].func
};
MaterialIcon.defaultProps = {
  size: 24,
  marginTop: 0
};
var _default = MaterialIcon;
exports["default"] = _default;